import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("submit", ".ajaxStaticForm", (e) => {
    e.preventDefault();
    let form = $(e.target);
    let errorEl = $(form.attr("data-error-target"));
    let successEl = $(form.attr("data-success-target"));
    let gaEvent = form.attr("data-ga-event-name");
    let showTimeout =
      parseInt(form.attr("data-success-show-timeout"), 10) || 3000;

    form.hide("fast");

    let data = form.serialize();
    successEl.hide("fast");
    errorEl.hide("fast");

    $.ajax({
      type: form.attr("method"),
      url: form.attr("action"),
      data: data,
    })
      .done((response) => {
        if (gaEvent) {
          window.gtag?.("event", gaEvent);
        }
        successEl.show("fast");
        setTimeout(() => {
          successEl.hide("fast");
          form[0].reset();
          form.show("fast");
        }, showTimeout);
      })
      .fail((response) => {
        successEl.hide("fast");

        form.show("fast");
        errorEl.show("fast");
      });
  });
});
